import React from "react";

export function PanelSessionDetailModalBody(props) {
    return (
        <div className="panel panelspecialsession">
            <div className="specialsession" id="aux">
                <div className="panel-body">
                    <span className="pull-right" title="Edit special session">
                        <span className="pull-right glyphicon glyphicon-edit openmodal-specialsession pointer"
                              onClick={props.handleEditSessionClick}>
                        </span>
                    </span>
                    <div className="specialsessiontype">{props.session.type}</div>
                    <div className="specialsessionchair">{props.session.data.chair}</div>
                    <div className="specialsessiontitle">{props.session.data.name}</div>
                    <div className="specialsessionauthor">{props.session.data.author}</div>
                    <div className="specialsessionabstract"></div>
                </div>
            </div>
        </div>
    )
}
